export type StepperStatus =
  | 'UNSPECIFIED'
  | 'REJECTED'
  | 'SUCCESS'
  | 'ON_PROGRESS';

export enum StepperStep {
  SUBMITTED = 'STEPPER_STEP_SUBMITTED',
  VERIFIED = 'STEPPER_STEP_VERIFIED',
  SUCCESS = 'STEPPER_STEP_SUCCESS',
  REJECTED = 'STEPPER_STEP_REJECTED',
}

export interface StepperContent {
  label?: string;
  date?: Date;
  status?: StepperStatus;
  descriptions?: string;
}

export interface StepperLinkedList {
  prev?: StepperStep;
  next?: StepperStep;
  current: StepperStep;
  content: StepperContent;
}
